const TIME_12H_RE = /^\s*(0?[1-9]|1[0-2])\s*(?::\s*([0-5]\d))?\s*(am|pm|a\.m\.|p\.m\.)\s*$/i;
const TIME_24H_RE = /^\s*([01]?\d|2[0-3])\s*:\s*([0-5]\d)\s*$/;

export function parseTime(input: string): string | null {
  if (!input || !input.trim()) return '';
  const trimmed = input.trim();

  let hour: number;
  let minute: number;

  const m12 = TIME_12H_RE.exec(trimmed);
  if (m12) {
    hour = parseInt(m12[1], 10);
    minute = m12[2] ? parseInt(m12[2], 10) : 0;
    const isPM = /p/i.test(m12[3]);
    if (hour === 12) hour = isPM ? 12 : 0;
    else if (isPM) hour += 12;
  } else {
    const m24 = TIME_24H_RE.exec(trimmed);
    if (!m24) return null;
    hour = parseInt(m24[1], 10);
    minute = parseInt(m24[2], 10);
  }

  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  const mm = String(minute).padStart(2, '0');
  return `${displayHour}:${mm} ${period}`;
}

export function isParseableTime(input: string | null | undefined): boolean {
  if (!input) return false;
  const result = parseTime(input);
  return result !== null && result !== '';
}
